<gridview-custom-element>
  <span class="d-none">{{ {entities, customer, config, materialTypes, page, translations} | json }}</span>
</gridview-custom-element>
